export default __webpack_public_path__ + "static/media/rectangular-board.51cb1711.svg";